const experienceData = [
    {
        company: "Centillion Labs",
        role: "Intern",
        location: "Bangalore (Remote)",
        duration: "Dec 2023 - Jan 2024" 
    },
    {
        company: "BabyFlix Inc.",
        role: "Python Developer",
        location: "San Francisco, California (Remote)",
        duration: "Feb 2024 - June 2024" 
    },
    {
        company: "Indian Institute of Technology Madras, Chennai",
        role: "Research Assistant - HTRA",
        location: "Chennai (Half Time)",
        duration: "Jul 2026 - Present"
    },
]

export default experienceData;
